<div *transloco="let t" class="flex max-h-[90vh] flex-col overflow-hidden">
  <header class="mt-5 flex shrink-0 items-center gap-3 pl-6">
    <div
      class="flex size-12 items-center justify-center rounded-3xl bg-blue-light p-3 text-blue"
    >
      <mat-icon
        class="material-icons-outlined items-center justify-center text-xl"
        style="display: inline-flex"
      >
        person_add
      </mat-icon>
    </div>
    <p class="text-lg font-semibold">
      {{ t('portal.users.creation.createText') }}
    </p>
  </header>

  <div class="flex min-h-0 grow items-center justify-center overflow-y-auto">
    <div class="w-full px-6 py-12">
      <form
        class="flex h-12"
        [formGroup]="userCreationForm"
        role="form"
        (keydown.enter)="
          userCreationForm.valid ? handleUserCreationSubmit() : null
        "
      >
        <app-text-input
          class="mr-2 w-1/4 grow"
          [control]="userCreationForm.controls.firstName"
          [controlName]="'firstName'"
          [placeholder]="t('portal.users.creation.form.firstName')"
        />
        <app-text-input
          class="mr-2 w-1/4 grow"
          [control]="userCreationForm.controls.lastName"
          [controlName]="'lastName'"
          [placeholder]="t('portal.users.creation.form.lastName')"
        />
        <app-text-input
          class="mr-2 w-1/2 grow"
          [control]="userCreationForm.controls.email"
          [controlName]="'email'"
          [placeholder]="t('portal.users.creation.form.email')"
        />
        <div class="ml-2 flex items-center">
          <span class="text-sm font-medium">
            {{ t('portal.users.creation.form.adminToggle') }}
          </span>

          <mat-icon
            class="material-icons-outlined ml-2 cursor-help text-base text-grey-midGrey"
            [matTooltip]="t('portal.users.creation.form.adminTooltip')"
            matTooltipPosition="above"
          >
            help_outline
          </mat-icon>

          <app-slide-toggle
            [checked]="userCreationForm.controls.isAdmin.value"
            (checkedChange)="userCreationForm.controls.isAdmin.setValue($event)"
          />
        </div>
      </form>
      <div class="my-10 flex items-center justify-between text-grey-lightGrey">
        <mat-divider class="material-divider flex-auto"></mat-divider>
        <span class="mx-4 text-sm text-primary">{{ t('general.or') }}</span>
        <mat-divider class="material-divider flex-auto"></mat-divider>
      </div>
      <div class="flex flex-col gap-5">
        @if (isHRISEnabled()) {
          <app-hris-integration-button />
        }
        <app-secondary-button
          [text]="t('portal.users.creation.csvUpload.csvUpload')"
          leadingIcon="cloud_upload"
          (buttonClicked)="handleCsvButtonClick()"
        ></app-secondary-button>
        <div class="flex items-center justify-center gap-1 text-xs">
          <span class="font-light text-grey">
            {{ t('portal.users.creation.csvUpload.example') }}
          </span>
          <app-link
            class="font-semibold"
            [description]="t('portal.users.creation.csvUpload.csvTemplate')"
            href="assets/csv/muster.csv"
          ></app-link>
        </div>
      </div>
    </div>
  </div>

  <footer class="w-full shrink-0 border-t-2 border-grey-lightGrey px-4 py-1">
    @if (userCreationForm.controls.isAdmin.value) {
      <div
        class="text-grey-dark mb-2 mt-3 flex items-center justify-center gap-2 rounded-lg bg-blue-light p-2 text-sm"
        [innerHTML]="t('portal.users.creation.passwordHint')"
      ></div>
    }
    <app-button-row
      [primaryButtonText]="t('portal.users.creation.create')"
      [secondaryButtonText]="t('general.back')"
      (primaryButtonClickedEvent)="handleUserCreationSubmit()"
      (secondaryButtonClickedEvent)="handleBackButtonClick()"
      [isLoading]="isLoading"
      [disablePrimaryButton]="!userCreationForm.valid || isLoading"
    ></app-button-row>
  </footer>
</div>
